import axios from '../utils/axiosConfig';

const vtuAPI = {
  // Products
  getProducts: async (params) => {
    const response = await axios.get('/vtu/products', { params });
    return response.data;
  },

  syncProducts: async () => {
    const response = await axios.post('/vtu/sync-products');
    return response.data;
  },

  // Network Detection
  detectNetwork: async (phone) => {
    const response = await axios.post('/vtu/detect-network', { phone });
    return response.data;
  },

  // Airtime
  purchaseAirtime: async (data) => {
    const response = await axios.post('/vtu/airtime/purchase', data);
    return response.data;
  },

  // Data
  getDataPlans: async (network, params = {}) => {
    const response = await axios.get(`/vtu/data-plans/${network}`, { params });
    return response.data;
  },

  purchaseData: async (data) => {
    const response = await axios.post('/vtu/data/purchase', data);
    return response.data;
  },

  // Transactions
  getTransactions: async (params) => {
    const response = await axios.get('/vtu/transactions', { params });
    return response.data;
  },

  // FIXED: Only use query params, no custom headers
  getTransactionSummary: async () => {
    const response = await axios.get('/vtu/transactions/summary', {
      params: {
        _t: Date.now(), // This alone is enough to prevent caching
      }
    });
    return response.data;
  },

  getTransaction: async (transactionId) => {
    const response = await axios.get(`/vtu/transactions/${transactionId}`);
    return response.data;
  },

  queryTransaction: async (transactionId) => {
    const response = await axios.post(`/vtu/transactions/${transactionId}/query`);
    return response.data;
  },

  retryTransaction: async (transactionId) => {
    const response = await axios.post(`/vtu/transactions/${transactionId}/retry`);
    return response.data;
  },
};

export default vtuAPI;